import { Link } from "react-router-dom";

// import { CostInfoItem } from "../CostDashboard/CostInfoItem";
import TodoPagination from "../TodoDashboard/component/todoNavigation";

import CommonChecklist from "./CommonChecklist";
import PageChecklist from "./PageChecklist";

const ActionBarComponent = ({
  src = "",
  page_name,
  pageObj = {},
  buttons = [],
  isChecklist = false,
  isDummy = false,
  links = [],
  showChecklist = false,
  showRightSidebar = false,
  setShowRightSidebar = false,
  actionFont14 = false,
  pageNo = 0,
  hasNext = false,
  hasPrev = false,
  goNext = () => {},
  goPrev = () => {},
}) => {
  const linkStyle = {
    color: "white", // Note camelCase instead of color: "white"
    textDecoration: "none", // textDecoration instead of text-decoration
  };
  const _temp = pageObj;
  return (
    <>
      {page_name === "Court Form Editor" || page_name === "Discovery Draft Editor" ? (
        <>
          <div
            className={`action-bar main-action-bar action-bar-editor-page client-BarAlign d-flex m-b-5 pr-15 ${isChecklist ? "has-checklist" : ""} ${showChecklist ? "has-checklist anti-action-bar anti-client-BarAlign" : ""} ${page_name === "Search" ? "search-action-bar" : ""} notes-action-bar`}
            style={{
              overflow: isChecklist ? "unset" : showChecklist ? "unset" : "initial",
              // zIndex: open ? "0" : "",
            }}
          >
            <span
              className="page-icon"
              style={{
                height: "35px",
                width: "35px",
                maxWidth: "35px",
                flex: "0 0 35px",

                // other styles can go here
              }}
            >
              {page_name === "Home" ? (
                <i className="ic ic-35 ic-home" />
              ) : page_name === "Gauge Page" ? (
                <img className="translate-note-icon" src={src} />
              ) : page_name === "Accounting" || page_name === "Accounting Trust Ledger" ? (
                <i className="ic ic-35 ic-accounting" />
              ) : pageObj?.id === 37 ? (
                <i className="ic ic-35 ic-accounting" />
              ) : (
                <img className="translate-note-icon" src={src} />
              )}
            </span>
            <>
              <div className="text-wrapper text-nowrap text-white d-flex align-items-center p-l-5 w-100">
                <div>
                  {actionFont14 ? (
                    <p
                      className="text-white mb-0 text-uppercase"
                      style={{
                        cursor: "default",
                      }}
                    >
                      {page_name}
                    </p>
                  ) : (
                    <h2
                      className="text-white mb-0"
                      style={{
                        cursor: "default",
                      }}
                    >
                      {page_name}
                    </h2>
                  )}
                </div>
                <div className="ms-auto">
                  {" "}
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      className={
                        "height-25 d-flex align-items-center justify-content-center btn btn-success"
                      }
                      onClick={() => setShowRightSidebar(!showRightSidebar)}
                    >
                      {showRightSidebar ? "Close" : "Open"} Controls
                    </button>
                  </span>
                </div>
              </div>
            </>
          </div>
        </>
      ) : (
        <div
          className={`action-bar main-action-bar client-BarAlign d-flex m-b-5 pr-15 ${isChecklist ? "has-checklist" : ""} ${showChecklist ? "has-checklist anti-action-bar anti-client-BarAlign" : ""} ${page_name === "Search" ? "search-action-bar" : ""} notes-action-bar`}
          style={{
            overflow: isChecklist ? "unset" : showChecklist ? "unset" : "initial",
            // zIndex: open ? "0" : "",
          }}
        >
          <span
            className="page-icon"
            style={{
              height: "35px",
              width: "35px",
              maxWidth: "35px",
              flex: "0 0 35px",
            }}
          >
            {page_name === "Home" ? (
              <i className="ic ic-35 ic-home" />
            ) : page_name === "Gauge Page" ? (
              <img className="translate-note-icon" src={src} />
            ) : page_name === "Accounting" || page_name === "Accounting Trust Ledger" ? (
              <i className="ic ic-35 ic-accounting" />
            ) : page_name === "Wrong Death" ? (
              <span className="translate-note-icon" />
            ) : page_name === "Litigation Central" ? (
              <i className="ic ic-35 ic-litigation" />
            ) : pageObj?.id === 37 ? (
              <i className="ic ic-35 ic-accounting" />
            ) : pageObj?.id === 78 ? (
              <i className="ic ic-35 ic-reports-updated" />
            ) : (
              <img className="translate-note-icon" src={src} />
            )}
          </span>
          <div className="text-wrapper text-nowrap text-white d-flex align-items-center p-l-5">
            {actionFont14 ? (
              <p
                className="text-white mb-0 text-uppercase"
                style={{
                  cursor: "default",
                  ...(page_name === "Documents" && { marginLeft: "5px" }),
                }}
              >
                {page_name}
              </p>
            ) : (
              <h2
                className="text-white mb-0"
                style={{
                  cursor: "default",
                  ...(page_name === "Documents" && { marginLeft: "5px" }),
                }}
              >
                {page_name}
              </h2>
            )}
          </div>
          {isChecklist && <PageChecklist pageObj={pageObj} />}

          {["WORKLIST", "Tasks"].includes(page_name) && (
            <TodoPagination
              pageNo={pageNo}
              hasNext={hasNext}
              hasPrev={hasPrev}
              onPrev={goPrev}
              onNext={goNext}
            />
          )}

          {showChecklist && <CommonChecklist />}
          {isDummy ? (
            <></>
          ) : (
            <>
              {page_name === "Treatment" && (
                <>
                  {links.map((link, index) => (
                    <Link key={index} to={link.to} style={linkStyle}>
                      <span className={link.className}>
                        {link.icon}
                        {link.label}
                      </span>
                    </Link>
                  ))}
                </>
              )}
              <div
                className="d-flex w-100 p-r-5 justify-content-end align-items-center"
                style={{ gap: "5px" }}
              >
                {buttons?.map((button, index) => (
                  <button
                    key={index}
                    type={button.type || "button"}
                    className={button.className || "btn btn-primary"}
                    onClick={button.onClick}
                    style={{ zIndex: "1", display: "flex", alignItems: "center" }}
                  >
                    <span className="fw-bold pe-2 ic-15 d-flex align-items-center justify-content-center text-gold">
                      {button.icon}
                    </span>
                    {button.label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ActionBarComponent;
